import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  ModalController,
} from "ionic-angular";
import { Observable } from "rxjs";
import moment from "moment";
import mqtt from "mqtt";
import { Network } from "@ionic-native/network";

import { AuthService } from "../../providers/api/auth.service";
import { NewsProvider } from "../../providers/news/news";
import { WeatherProvider } from "../../providers/weather/weather";
import { WEATHER_ICONS } from "../../providers/weather/weather.enum";
import { TransportsProvider } from "../../providers/transports/transports";
import { Settings } from "../../providers";
import { DoorBellProvider } from "../../providers/door-bell/door-bell";
import { environment } from "../../environments/environment";

@IonicPage()
@Component({
  selector: "page-dashboard",
  templateUrl: "dashboard.html",
})
export class DashboardPage {
  private connectSubscription$: any;
  private disconnectSubscription$: any;
  private forecastSubscription$: any;
  private forecastSubscriptionInterval: number = 60 * 60 * 1000;

  public forecast: any;

  public WEATHER_ICONS: any = WEATHER_ICONS;

  public newsObj = [];
  public transportsObj = [];
  private userID;

  constructor(
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public weather: WeatherProvider,
    private auth: AuthService,
    private network: Network,
    private news: NewsProvider,
    private transports: TransportsProvider,
    public settings: Settings,
    private doorBellProvider: DoorBellProvider
  ) {
    if (this.auth.getAuthUser()) {
      this.userID = this.auth.getAuthUser()._id;
    }

    this.disconnectSubscription$ = this.network.onDisconnect().subscribe(() => {
      this.forecastSubscription$.unsubscribe();
    });

    this.connectSubscription$ = this.network.onConnect().subscribe(() => {
      // Wait a bit to be sure connection has restablished
      setTimeout(() => {
        if (this.network.type === "ethernet") {
          this.forecastSubscription$ = Observable.interval(
            this.forecastSubscriptionInterval
          ).subscribe(() => {
            this.updateForecast();
          });
        }
      }, 3000);
    });
  }

  ionViewDidEnter() {
    this.getNews(this.userID, 3);
    this.getTransports(this.userID, 3);
  }

  ngOnInit() {
    this.updateForecast();
    this.forecastSubscription$ = Observable.interval(
      this.forecastSubscriptionInterval
    ).subscribe(() => {
      this.updateForecast();
    });
  }

  getNews(id, limit) {
    this.news.getNewsByID(id, limit).subscribe((data: any) => {
      if (!data.error) {
        this.newsObj = data;
      }
    });
  }

  getTransports(id, limit) {
    this.transports.getTransportsByID(id, limit).subscribe((data: any) => {
      if (!data.error) {
        this.transportsObj = data;
      }
    });
  }

  updateForecast() {
    this.weather.getCoordinates().subscribe((res: any) => {
      this.weather.getForecast().subscribe((data: any) => {
        if (data) {
          var arrayTemp = [];
          for (var i = 1; i < 5; i++) {
            if (data.list) {
              var item = data.list[i];
              arrayTemp.push({
                day: moment.unix(item.dt).format("dddd"),
                icon: item.weather[0].icon,
                max: Math.round(item.temp.max),
                min: Math.round(item.temp.min),
              });
            }
          }
          this.forecast = arrayTemp;
        }
      });
    });
  }

  ionViewDidLoad() {
    console.log('Theres someone there?');
    this.mqttActivate();
  }

  goNews(PIDnumber: any) {
    this.navCtrl.setRoot("NewsPage", { PID: PIDnumber });
  }

  goTransports(PIDnumber: any) {
    this.navCtrl.setRoot("TransportsPage", { PID: PIDnumber });
  }

  mqttActivate() {
    console.log('Activating mqtt');
    this.doorBellProvider.storeDoorBellTopic();
    this.settings.doorbellTopic().subscribe((topic) => {
      const options = {
        host: environment.production
          ? "gzih.gozmart.ch"
          : "gzih-dev.gozmart.ch",
        port: 9001,
        reconnectPeriod: 1000
      };
      const client = mqtt.connect(options);

      client.on("connect", function () {
        client.subscribe(topic, function (err) {
          if (err) {
            console.log(err);
          }
        });
      });

      const doorbell = this.doorBellProvider;

      client.on("message", function (topic, message) {
        if (message.toString() === "1") {
          doorbell.activateDoorBell();
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.forecastSubscription$) {
      this.forecastSubscription$.unsubscribe();
    }
    if (this.connectSubscription$) {
      this.connectSubscription$.unsubscribe();
    }
    if (this.disconnectSubscription$) {
      this.disconnectSubscription$.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts